import { useRef } from "react";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import Modal from "@components/modal/modal";
import ModalTitle from "@components/modal/modal-title";

/** Asked when an admin heads away from the form with changes they have not
 * saved: save them, throw them away, or stay. */
const ProgramFormLeaveDialog = ({
  open,
  nounLower,
  saveLabel,
  onSave,
  onDiscard,
  onCancel,
}: {
  open: boolean;
  nounLower: string;
  saveLabel: string;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}) => {
  const saveButtonRef = useRef(null);
  return (
    <Modal
      open={open}
      onClose={onCancel}
      alignedTop
      className="z-tooltip"
      initialFocus={saveButtonRef}
    >
      <div
        aria-label="Unsaved changes dialog"
        className="p-6 flex flex-col gap-4"
      >
        <ModalTitle onClose={onCancel}>Save your changes?</ModalTitle>
        <div>
          You have changes to this {nounLower} that have not been saved.
        </div>
        <div className="mt-6 flex items-center gap-2">
          <Button
            theme={buttonTheme.redDanger}
            onClick={onDiscard}
            text="Discard changes"
          />
          <div className="flex-1" />
          <Button
            theme={buttonTheme.text}
            onClick={onCancel}
            text="Keep editing"
          />
          <Button
            ref={saveButtonRef}
            theme={buttonTheme.primary}
            onClick={onSave}
            text={saveLabel}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ProgramFormLeaveDialog;
